import api from '@pray/shared/utils/api';

export interface ContentStatsResponse {
  data: {
    total: number;
    published: number;
    scheduled: number;
    draft: number;
  };
}

export interface ContentStats {
  total: number;
  published: number;
  scheduled: number;
  draft: number;
}

type GetContentStatsProps = {
  artistId: string;
};

export const getContentStats = async ({ artistId }: GetContentStatsProps): Promise<ContentStats> => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/content/stats`;
  const response = await api.executeGetRequest<ContentStatsResponse>(url);

  return response.data.data;
};
